<template>
  <div class="flex gap-2 text-sm">
    <span class="iconify svg--truck-empty shrink-0 mt-1" />
    <div class="flex gap-2 flex-1 flex-wrap">
      <div class="font-normal flex flex-col flex-1">
        <span v-if="isFree">
          {{ $t('FREE DELIVERY') }}
        </span>
        <span v-else>
          {{ $t('Delivery') }}
        </span>
        <span>
          {{ approximateDeliveryDate }}
        </span>
      </div>
      <span class="text-EXPONDO-green font-bold self-end">
        {{ shippingCostLabel }}
      </span>
    </div>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'CartDeliveryInfo',

  props: {
    approximateDeliveryDate: {
      type: String,
      required: true,
    },
    shippingCostLabel: {
      type: String,
      required: true,
    },
    isFree: {
      type: Boolean,
      required: true,
    },
  },
});

</script>
